import React from 'react';
import {Download, File} from "react-feather";
import {getConversationFiles} from "../../../services/api/messaging";
import {formatBytes} from "../../../services/helpers";

function AdminMessageFiles({conversationID, files, shortName = false}) {
    const handleDownloadFile = (file) => {
        getConversationFiles(conversationID, file.location).then(response => {
            const downloadLink = document.createElement("a");
            downloadLink.href = response.url;
            downloadLink.download = file.name;
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        });
    };

    return (
        <div>
            {files.length > 0 ? (
                <div
                    className="sl-w-full sl-flex sl-flex-col sl-gap-2 sl-align-center sl-justify-center">
                    {files.map((file, index) => (
                        <div
                            key={index}
                            rel={file.id}
                            className='sl-flex sl-bg-white sl-rounded-lg sl-shadow-xs sl-pb-2-last-0 sl-px-1 sl-py-2 sl-rounded-lg sl-w-fill-available sl-justify-space-between sl-align-center'>
                            <div
                                className="sl-flex sl-w-full sl-justify-start sl-align-center sl-gap-3 sl-mb-2">
                                <div>
                                    <div
                                        className="sl-p-2 sl-m-auto sl-w-8 sl-h-8 sl-rounded-full sl-bg-primary-50 sl-text-primary-600">
                                        <File size={16} className="sl-text-primary-600"/>
                                    </div>
                                </div>

                                <div
                                    className="sl-grow-1 sl-w-full sl-flex sl-flex-col sl-justify-items-start sl-align-flex-start">
                                    <div
                                        className="sl-font sl-text-sm sl-font-medium sl-text-gray-900 sl-mr-1">
                                        {(file.name.length > 22 && shortName) ? file.name.substring(0, 18) + "..." : file.name}
                                    </div>
                                    {file.size &&
                                    <div
                                        className="sl-font-normal sl-text-xs sl-text-gray-base">
                                        {formatBytes(file.size)}
                                    </div>}
                                </div>

                                <button
                                    className="sl-btn sl-btn-md sl-btn-clear sl-p-2-point-5 sl-max-h-10 sl-max-w-10 sl-self-end"
                                    onClick={() => handleDownloadFile(file)}>
                                    <Download size={20}
                                              className="sl-cursor-pointer sl-text-gray-base"/>
                                </button>
                            </div>
                        </div>))}
                </div>) : (
                <div>/</div>
            )}
        </div>
    );
}

export default AdminMessageFiles;
